/* eslint-disable import/prefer-default-export */
export const markdownKeywords = {
  keyword: ['for', 'while', 'if', 'else', 'in', 'each', 'do',
    'repeat', 'until', 'Empty', 'Locate', 'of', 'not', 'downto', 'and', 'or', 'return', 'NotFound'],
  operator: ['<', '>', '+', '-'],
  arrow: ['<-'],
};
